<template>
    <div class="page bgF5F5F5">

        <div style="height: 46px; line-height: 46px;">
            <header class="pageHeader paddingH16 paddingV8 white_bg">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 11px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px"></div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">

            <!-- 头像基本资料栏 -->
            <div style="padding: 24px 0 22px;">
                <div class="paddingH16">
                    <div class="imageArea size64 marginR12 fl">
                        <img class="circle fullSpace cover" v-if="dataItem && dataItem.headImage" :src="dataItem.headImage"/>
                    </div>
                    <div class="" style="padding: 13px 0 9px;">
                        <strong class="color333 bold font18r" style="margin-right: 6px;">{{dataItem ? dataItem.name : ''}}</strong>
                        <span class="textLabel font11r white" style="background: linear-gradient(90deg, #FF4D48 0%, #FF8A5F 100%);
                            height: 15px; line-height: 15px; padding: 0 4px;">主办方</span>
                    </div>
                    <div class="font12r darkgrey">合作截止时间：{{dataItem ? formatDate(dataItem.expireTime) : '未知'}}</div>
                </div>
            </div>

            <div class="white_bg" style="padding: 16px 18px; border-radius: 16px 16px 0 0;">

                <van-tabs sticky title-inactive-color="#5B616C" title-active-color="#333333"
                      line-width="20" line-height="3" color="#FFBC3B">
                    <van-tab title="主办方资料">
                        <div class="bgF5F5F5 roundBorder4 marginT20 marginB16">
                            <div class="bgInherit" style="padding: 15px 16px;">
                                <div class="color333 bold font14r">主办方简介</div>
                                <div class="darkgrey font12r descArea lineHeight21r12f bgInherit" style="margin-top: 13px;">
                                    <collapsibleContainer :content="dataItem ? dataItem.introduce : ''" :maxHeight="'9em'"/>
                                </div>
                            </div>

                        </div>

                        <div class="divisionLine"></div>

                        <div class="paddingV16 color333 font14r bold">
                            主办方风采
                        </div>

                        <div class="gridLayout grid3column marginB16" style="grid-column-gap: 14px;" v-if="dataItem && dataItem.imgList">
                            <div class="roundBorder8 hiddenOverflow" style="height: 27.73vw;"
                                 v-for="(image, index) in dataItem.imgList" :key="index">
                                <img class="fullSpace cover" :src="image" v-gallery:organizationImages/>
                            </div>
                        </div>

                        <div class="alignC font14r" v-else="">暂无任何内容</div>

                        <div class="divisionLine"></div>

                        <table class="contactInfoTable w100p color333 font14r">
                            <tr>
                                <th align="left">联系方式</th>
                                <td align="right">
                                    <a class="color333" :href="'tel:' + (dataItem ? dataItem.phone : '')">
                                        {{dataItem ? dataItem.phone || '未填写' : '' }}
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <th align="left">联系邮箱</th>
                                <td align="right">
                                    <a class="color333" :href="'mailto:' + (dataItem ? dataItem.email : '')">
                                        {{dataItem ? dataItem.email || '未填写' : '' }}
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <th align="left">主办方地址</th>
                                <td align="right" style="max-width: 200px">
                                    <span @click="viewAddress(dataItem)">{{dataItem ? dataItem.address || '' : ''}}</span>
                                </td>
                            </tr>

                        </table>

                        <div style="margin-top: 36px;">
                            <button class="orangeButton block w100p" style="height: 42px; line-height: 42px; border-radius: 21px;"
                                @click="editProfile()">修改资料</button>
                        </div>
                    </van-tab>

                    <van-tab title="活动管理">
                        <div class="marginT20">
                            <courseList/>
                        </div>
                    </van-tab>

                </van-tabs>

            </div>

            <div style="height: 50px;"></div>

        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// modules and components
import {Tab, Tabs} from 'vant';
import courseList from './courseList';
import collapsibleContainer from '@/components/collapsibleContainer';

// util
import appHelper    from '@/util/appHelper';
import consoleApi   from '@/components/platformApi/consoleApi';

const config = {
    name : 'underlineCourseSponsorPersonalCenter',
    title : '主办方个人中心',
    description : '',
    apiConfig : {
        get : {
            url : 'portal/underline/v2/sponsor/get',
            dataPath : 'data',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {
        'van-tab': Tab,
        'van-tabs': Tabs,
        courseList, collapsibleContainer
    },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,

            enableDataItem : true,
            autoLoadDataItem : true,

            desc : {
                collapsed : true
            },

            tabModule : {
                panels : [{
                    title : '主办方资料',
                },{
                    title : '活动管理',
                }],
                activePanel : null
            }
        }
    },
    methods : {
        // onLoadDataItem : function () {
        //     this.setWechatShare();
        // }
        editProfile() {
            appHelper.goToPage('underlineCourseSponsorEditProfile');
        },
        viewAddress(dataItem) {
            let params = '';
            if (dataItem.city)
            {
                params += '&region=' + dataItem.city;
            }
            let url = 'https://apis.map.qq.com/uri/v1/search?keyword=' + dataItem.addr + params + '&referer=KVRBZ-XCAC3-PNY3I-3G27S-XHYV6-7NBWU';
            appHelper.redirect(url);
        }
    },
    mounted() {

        if (appConfig.mode === 'demo')
        {
            this.dataItem = {
                id : 1,
                title : '',
                coverImg : appHelper.getRandomCoverImage(),
                userHead : appHelper.getRandomCoverImage()
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.darkgrey {
    color: #5B616C;
}
.gold {
    color: #C9821A;
}
.divisionLine {
    height: 1px;
    line-height: 1px;
    background: #F5F5F5;
}
.contactInfoTable {
    th, td {
        padding: 12px 0;
    }
}
.descArea {
    &.collapsed {
        max-height: 9em;
    }
}

</style>
